<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
        <div class="section-1400 pt-xl-4">
            <div class="container-fluid padding-top-40">

                <div class="row justify-content-center">
                    <div class="col-lg-8">

                        <!-- Event Title Header -->
                        <div class="card border-0 landing-shadow-4 mb-4" *ngIf="eventTitle">
                            <div class="card-body p-4 text-center">
                                <i class="uil uil-calendar-alt size-40 color-primary"></i>
                                <h5 class="mt-3 mb-0 color-primary">{{ eventTitle }}</h5>
                            </div>
                        </div>

                        <!-- ARIA Tab bar -->
                        <div class="pub-tab-bar mb-0" role="tablist" aria-label="Event sections" *ngIf="eventTitle">
                            <button class="pub-tab-btn"
                                    role="tab"
                                    id="tab-registration"
                                    aria-controls="panel-registration"
                                    [attr.aria-selected]="activeTab === 'registration'"
                                    [attr.tabindex]="activeTab === 'registration' ? 0 : -1"
                                    [class.active]="activeTab === 'registration'"
                                    (click)="setTab('registration')"
                                    (keydown)="onTabKeydown($event, 'registration')">
                                <i class="uil uil-edit-alt mr-2"></i>Event Registration
                            </button>
                            <button class="pub-tab-btn"
                                    role="tab"
                                    id="tab-attendees"
                                    aria-controls="panel-attendees"
                                    [attr.aria-selected]="activeTab === 'attendees'"
                                    [attr.tabindex]="activeTab === 'attendees' ? 0 : -1"
                                    [class.active]="activeTab === 'attendees'"
                                    (click)="setTab('attendees')"
                                    (keydown)="onTabKeydown($event, 'attendees')"
                                    >
                                <i class="uil uil-users-alt mr-2"></i>Event Attendees
                            </button>
                        </div>

                        <!-- Tab panels -->
                        <div class="pub-panel-wrapper" *ngIf="eventId">
                            <div id="panel-registration"
                                 role="tabpanel"
                                 aria-labelledby="tab-registration"
                                 *ngIf="activeTab === 'registration'">
                                <app-register-event [externalEventId]="eventId"></app-register-event>
                            </div>

                            <div id="panel-attendees"
                                 role="tabpanel"
                                 aria-labelledby="tab-attendees"
                                 *ngIf="activeTab === 'attendees'">
                                <app-event-attendees [externalEventId]="eventId"></app-event-attendees>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
